import * as React from "react"
import styled from "@emotion/styled"
import { theme, rr } from "../../styles/styleGuide"
import Svg from "../../assets/mobile/svg/showcase.inline.svg"
import { opacify } from "polished"
import websitesVid from "../../assets/mobile/videos/showcaseWebsitesMobile.mp4"
import motionVid from "../../assets/mobile/videos/showcaseMotionMobile.mp4"
var color = theme.color,
  font = theme.font,
  description = {
    website:
      "The website has a live interactive demo for re-designing an old website while scrolling, I used GSAP, Lotty-web, and Swiper to build this website, check it out!",
    motion:
      "This video is a promotional video for my services as a web designer, It shows design methods and tools that I use for building websites, Check it out!",
  }

function Showcase() {
  return (
    <Container id="showcase">
      <Clip className="clip">
        <SlidesContainer className="slides-container">
          <Video src={motionVid} className="motion" />
          <Video src={websitesVid} className="websites" />
          <SlidesHolder className="slides-holder">
            <Development color={color.showcase.website.primary} />
            <Slide
              tilte={{ upper: "promo", lower: "website" }}
              color={color.showcase.website.primary}
              backColor={color.showcase.website.background}
              linkUrl="https://ah-promo-site.netlify.app/"
              description={description.website}
              tags={[
                "creative-design",
                "responsive",
                // "loading-anim",
                "live-redsign",
                "scroll-anim",
                // "parallax-anim",
              ]}
            />

            <Motion color={color.showcase.motion.primary} />
            <Slide
              tilte={{ upper: "promo", lower: "video" }}
              color={color.showcase.motion.primary}
              backColor={color.showcase.motion.background}
              linkUrl="https://www.youtube.com/watch?v=zETxni8ZfrU"
              description={description.motion}
              tags={[
                "design-secrets",
                "big-text",
                "design-trends",
                // "video-filters",
                "audio-montage",
                // "glitch-animation",
              ]}
            />
          </SlidesHolder>
        </SlidesContainer>
        <Border className="border" />
      </Clip>
      <Title />
    </Container>
  )
}
const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  ${rr("height", "vh", 91.4)}
  overflow: hidden;
`
const Border = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  ${rr("border", ` solid ${color.showcase.website.primary}`, "2.4vw", "2.4vw", "2.1vw")}
  box-sizing: border-box;
`
const Clip = styled.div`
  height: 100%;
  width: 100%;
  clip-path: inset(0% 0% 0% 0%);
`
const Title = () => {
  const Text = styled.div`
    #showcase-title-svg {
      position: absolute;
      top: 52%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 75%;
      .cls-1 {
        fill: ${color.showcase.website.primary};
      }

      .cls-2 {
        ${rr("stroke-width", "vw", 0.5, 0.6, 0.3)}
        stroke: ${color.showcase.website.background};
        fill: none;
      }

      .cls-3 {
        fill: ${color.showcase.website.background};
      }
    }
  `
  const Border = styled.div`
    position: absolute;
    box-sizing: border-box;
    width: 100vw;
    height: 12%;
    top: 0;
    left: 0;
    background-color: ${color.showcase.website.primary};
  `

  return (
    <Border className="section-title">
      <Text>
        <Svg />
      </Text>
    </Border>
  )
}
interface slide {
  tilte: {
    upper: string
    lower: string
  }
  description: string
  tags: string[]
  linkUrl: string
  color: string
  backColor: string
}
const Slide: React.FC<slide> = ({
  tilte,
  tags,
  description,
  linkUrl,
  color: mainColor,
  backColor,
}) => {
  const Title = () => {
    const Text = styled.span`
      ${rr("font-size", "vw", 19, 16, 12)}
      ${font.title};
      color: ${mainColor};
      line-height: 0.9;
    `
    const Holder = styled.h2`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    `
    return (
      <Holder>
        <Text>{tilte.upper}</Text>
        <Text>{tilte.lower}</Text>
      </Holder>
    )
  }
  const Description = styled.span`
    ${rr("font-size", "vw", 3.9, 3.9, 3.3)}
    line-height: 1.2;
    color: ${mainColor};
    width: 80vw;
    ${rr("margin-bottom", "%", 20, 10, 6)}
    /* margin-bottom: -3em; */
    ${font.content.medium}
  `
  const Tag = () => {
    const Tag = styled.span`
      ${rr("font-size", "vw", 3.5, 3.5, 2.9)}
      ${font.content.bold};
      color: ${mainColor};
      background-color: ${opacify(-0.8, mainColor)};
      padding: 0.3em 0.6em;
      border-radius: 2em;
      margin: 0.5em 0.5em 0.1em 0em;
      opacity: 0.8;
      &:before {
        content: "#";
        color: inherit;
      }
    `
    const TagHolder = styled.div`
      width: 80vw;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      /* justify-content: center; */
    `
    var items = []
    for (let i = 0; i < tags.length; i++) {
      items.push(<Tag key={i}>{tags[i]}</Tag>)
    }
    return <TagHolder>{items}</TagHolder>
  }

  const Preview = styled.a`
    display: inline-block;
    ${rr("font-size", "vw", 7.3, 7, 6)}
    padding: 0.4em 1em;
    background-color: ${mainColor};
    box-sizing: border-box;
    color: ${backColor};
    text-decoration: none;
    border-radius: 0.2em;
    ${font.content.bold};
    &:visited {
      color: ${backColor};
    }
    &:active {
      background-color: transparent;
      color: ${mainColor};
      border: solid 0.15em ${mainColor};
      padding: 0.25em 0.85em;
    }
  `
  const TextHolder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    ${rr("margin-top", "%", 9, 4, 3)}
    ${rr("margin-bottom", "%", 12, 12, 7)}
  `
  const Holder = styled.div`
    position: relative;
    width: 100vw;
    ${rr("height", "vh", 80)}
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `

  return (
    <Holder>
      <TextHolder>
        <Title />
        <Description>{description}</Description>
        <Tag />
      </TextHolder>
      <Preview href={linkUrl} target="_blank">
        Preview
      </Preview>
    </Holder>
  )
}
interface video {
  src: string
  className: string
}
const Video: React.FC<video> = ({ src, className }) => {
  const Video = styled.video`
    position: absolute;
    width: 100vw;
    ${rr("bottom", "vh", -0, -10, -20)}
  `
  return <Video src={src} className={className} loop muted autoPlay playsInline />
}
// interface slideTitle {
//   upper: string
//   lower: string
//   color: string
// }
// const SlideTitle: React.FC<slideTitle> = ({ upper, lower, color: mainColor }) => {
//   const Text = styled.h1`
//     ${rr("font-size", "vw", 36, 34, 28)}
//     line-height: 1.1;
//     margin: -1.2vw;
//     ${font.title};
//     color: ${mainColor};
//   `
//   const TextHolder = styled.div`
//     position: relative;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     ${rr("height", "vh", 90)}
//     transform: rotate(-90deg) translate(-6%, 1%);
//   `
//   const Holder = styled.div`
//     display: flex;
//     flex-direction: row;
//     width: 100vw;
//     align-items: center;
//     justify-content: center;
//   `
//   return (
//     <Holder>
//       <TextHolder>
//         <Text>{upper}</Text>
//         <Text>{lower}</Text>
//       </TextHolder>
//     </Holder>
//   )
// }
interface titleColor {
  color: string
}
const Development: React.FC<titleColor> = ({ color }) => {
  const D = styled.span`
    font-size: 10em;
    color: ${color};
    ${font.title}
  `
  const Row = styled.div`
    -webkit-text-stroke: ${color};
    -webkit-text-stroke-width: 0.02em;
    color: transparent;
    font-size: 2em;
    ${font.title}
  `
  const RowsHolder = styled.div`
    margin-top: -3em;
    margin-bottom: -3em;
    margin-right: 0.3em;
    line-height: 1;
  `
  const Holder = styled.div`
    font-size: 13vw;
    ${rr("height", "vh", 80)}
    transform: translateX(-4%);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0;
  `
  return (
    <Holder>
      <D>D</D>
      <RowsHolder>
        <Row>eve</Row>
        <Row>lop</Row>
        <Row>ment</Row>
      </RowsHolder>
    </Holder>
  )
}
const Motion: React.FC<titleColor> = ({ color }) => {
  const M = styled.span`
    font-size: 4.4em;
    color: ${color};
    ${font.title}
  `
  const G = styled.span`
    font-size: 5.3em;
    color: ${color};
    ${font.title}
  `
  const Row = styled.div`
    -webkit-text-stroke: ${color};
    -webkit-text-stroke-width: 0.02em;
    color: transparent;
    font-size: 2em;
    ${font.title}
  `
  const RowsHolder = styled.div`
    margin-top: -3em;
    margin-bottom: -3em;
    line-height: 0.76;
  `
  const Secction = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    padding: 0;
    line-height: 0.71;
  `
  const Holder = styled.div`
    ${rr("font-size", "vw", 18, 17.7, 14.7)}
    transform: translateX(-2.5%);
    ${rr("height", "vh", 80)}
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin: 0;
  `
  return (
    <Holder>
      <Secction className="motion">
        <M>M</M>
        <RowsHolder>
          <Row>ot</Row>
          <Row>ion</Row>
        </RowsHolder>
      </Secction>
      <Secction>
        <G>G</G>
        <RowsHolder>
          <Row>rap</Row>
          <Row>hics</Row>
        </RowsHolder>
      </Secction>
    </Holder>
  )
}
const SlidesHolder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  left: 0;
  top: 0;
  width: 100vw;
`
const SlidesContainer = styled.div`
  position: absolute;
  bottom: 1%;
  height: 87%;
  width: 100vw;
  overflow: hidden;
  background-color: ${color.showcase.website.background};
`

export default Showcase
